// API Base Url
export const API_BASE_URL =
  import.meta.env.VITE_API_BASE_URL || 'https://api.example.com';
export const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN;
export const SENTRY_ENVIRONMENT = import.meta.env.VITE_SENTRY_ENVIRONMENT;
export const SENTRY_RELEASE = import.meta.env.VITE_SENTRY_RELEASE;

// Sessions
export const LOGIN = '/sessions/sign_in';
export const REGISTER = '/sessions/register';
export const SEND_OTP = '/sessions/send_otp';
export const VALIDATE_OTP = '/sessions/validate_otp';
export const CREATE_PASSWORD = '/sessions/set_password';
export const FORGOT_PASSWORD = '/patients/forgot_password';
export const RESET_PASSWORD = '/patients/reset_password';

// Dashboard - Appointments
export const APPOINTMENTS = '/appointments';
export const APPOINTMENTS_API = '/appointments';
export const MEDICATIONS_API = '/medications';

// Profile Details

export const PROFILE = '/patients/:id';

// Surgery Details

// Tasks
export const TASK_LIST = '/questionnaires/list_history';
export const PATIENT_QUESTIONNAIRES = '/patient_questionnaires';
export const ALLERGY_LIST = 'patient/:id/show_allergies';
export const MEDICATION_LIST = '/medications';
export const MEDICATION_REMINDER = '/medication_reminders';
export const MEDICATION_CONSISTENCY = '/medication_consistency';

// Profile
export const PROFILE_API = '/patients';

// Payment
export const PAYMENTS_API_ENDPOINT = '/payments';

// Download invoice
export const DOWNLOAD_INVOICE_API_ENDPOINT = '/invoices/generate_invoice';
export const DOWNLOAD_RECEIPT_API_ENDPOINT = '/receipts/generate_receipt';